import { sv } from "date-fns/locale";
import { AvailabilityDto, BookingDto, BookingStatus, SlotType } from "../Types/BookingServiceTypes"
import { CombineDateAndTimeOnly, DateOnly, TimeOnly } from "./DateManagement"
import { format } from "date-fns";
import { AdminTimeSlot } from "../Pages/AdminPages/AdminBookings";
const MapToAvailabilityDto = async (slots:AdminTimeSlot[]):Promise<AvailabilityDto[]> => {
  console.log('DATA IN I MAPPNING',slots);
  const result =await slots.map(x => {
          const buffEndTime = new Date(`${x?.date} ${x?.time}`);
          buffEndTime.setHours(buffEndTime.getHours()+1);
          const mappedAvailability:AvailabilityDto ={
                id: -1,
                date:new DateOnly(x?.date),
                startTime:  new TimeOnly(x?.time),
                endTime: new TimeOnly(buffEndTime.toLocaleTimeString('sv-SE',{hour:'2-digit',minute:'2-digit'})),
                maxBookings: 1,
                category: x?.category ?? 'public',
                createdAt: new Date(),
                updatedAt:new Date()
                };
                return mappedAvailability;
              });
              console.log('DATA UT UR MAPPING',result);      
              return result;           
  
}
const MapToTimeSlots = async(availableSlots:AvailabilityDto[]):Promise<SlotType[]> =>{
    return await availableSlots.map(x => {
        
        const dateOnly = x.date.getDateOnly();
        const startTime = x.startTime.getTime();
        const date = CombineDateAndTimeOnly(dateOnly,startTime);
        const dateStr = format(date, "yyyy-MM-dd");
        const dayName = format(date, "EEEE", { locale: sv });
        const timeSlot:SlotType = {
        id: `${dateOnly}-${startTime}`,
        date: dateStr,
        time: startTime,
        dayName: dayName,
        available: true,
        tableId:x.id
        };
        return timeSlot;
    });   
}
const MapToBookingDtos = async(value:any[]):Promise<BookingDto[]> => {
  const mappedResult:BookingDto[] = await value.map(x => {
      const mappedAvailability:AvailabilityDto ={
                id: x?.slot?.id ?? -1,
                date:new DateOnly(x?.slot?.date),
                startTime:  new TimeOnly(x?.slot?.startTime),
                endTime: new TimeOnly(x?.slot?.endTime),
                maxBookings: x?.slot?.maxBookings,
                category: x?.slot?.category ?? 'public',
                createdAt: new Date(x?.slot?.createdAt),
                updatedAt:new Date(x?.slot?.updatedAt)
                };
      const mappedBooking:BookingDto = {
             id:x?.id,
             slotId:x?.slotId,
             slot:mappedAvailability,
             applicationUserId:x?.applicationUserId,
             name:x?.name,
             email:x?.email,
             swishTransactionID:x?.swishTransactionID,
            bankIdVerified:x?.bankIdVerified,
            status:x?.status as BookingStatus,
            createdAt:new Date(x?.createdAt),
            updatedAt:new Date(x.updatedAt),
            notes:x?.notes,
            materialSent:x?.materialSent
     };
     return mappedBooking;            
   });
   return mappedResult;
}
export const GlobalObjectMapping ={
    MapToTimeSlots,
    MapToBookingDtos,
    MapToAvailabilityDto
}
